import { render, staticRenderFns } from "./zfbFail.vue?vue&type=template&id=f3c0b4ea&scoped=true&"
import script from "./zfbFail.vue?vue&type=script&lang=js&"
export * from "./zfbFail.vue?vue&type=script&lang=js&"
import style0 from "./zfbFail.vue?vue&type=style&index=0&id=f3c0b4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c0b4ea",
  null
  
)

export default component.exports